import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=7ae35de0&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=7ae35de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae35de0",
  null
  
)

export default component.exports